import { Component } from '@angular/core';
import { SettingsService } from '../settings/settings.service';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { all } from '@awesome.me/kit-787edf9aa0/icons';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [
    FontAwesomeModule
  ],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent {
  version: string = 'not set'; // = this.settingsService.version; //import.meta.env['NG_APP_VERSION'];
  apiUrl: string | undefined;

  constructor(
    private settingsService: SettingsService,
    public faIcons: FaIconLibrary,

  ) {
    this.version = this.settingsService.version;
    this.apiUrl = this.settingsService.settings?.apiUrl
    faIcons.addIcons(...all);
  }

}
